import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';

@Component({
  selector: 'app-top-navbar',
  templateUrl: './top-navbar.component.html',
  styleUrls: ['./top-navbar.component.scss'],
})
export class TopNavbarComponent implements OnInit {

  user: any = null;
  constructor(private globalService: GlobalService) { }

  ngOnInit() {
    this.GetUser();
  }

  async GetUser() {
    this.user = await this.globalService.GetUser();
    console.log(this.user);
    console.log(this.user.profile_picture);
  }

}
